// Bilingual Help content — verbatim from the printed HAG Carpets Ops guide.
// Ships with the app bundle (no network fetch) so it opens fully offline.

export const ROLE_GUIDES = {
  inspector: {
    title: { en: "Inspector — 6 Daily Steps", hi: "इंस्पेक्टर — दैनिक 6 चरण" },
    sections: [
      {
        id: "insp-daily",
        heading: { en: "Daily steps", hi: "रोज़ के चरण" },
        items: [
          { en: "Log in with your phone number. Keep GPS ON — the app will not accept photos without it.",
            hi: "अपने फोन नंबर से लॉगिन करें। GPS हमेशा चालू रखें।" },
          { en: "Check Today's Route. Red / pinned looms are overdue — visit them first.",
            hi: "आज का मार्ग देखें। लाल करघे पहले जाएँ।" },
          { en: "At the loom tap Start Inspection and select the milestone. Milestones cannot be skipped.",
            hi: "निरीक्षण शुरू करें और मील-स्टोन चुनें। मील-स्टोन छोड़े नहीं जा सकते।" },
          { en: "Fill measurements, the 5 checklists, and take at least 1 photo (max 6).",
            hi: "माप, 5 चेकलिस्ट भरें, कम से कम 1 फोटो लें।" },
          { en: "Grade the loom A / B / C. If you override the suggested grade, write the reason.",
            hi: "ग्रेड A/B/C दें। बदलने पर कारण लिखें।" },
          { en: "Submit. With signal it syncs now; without, it saves and syncs later automatically.",
            hi: "सबमिट करें। सिग्नल न होने पर बाद में अपने आप सिंक होगा।" },
        ],
      },
      {
        id: "insp-offline",
        heading: { en: "Working offline", hi: "ऑफलाइन काम" },
        items: [
          { en: "The app works fully offline. A yellow banner counts unsynced records; RED banner = records older than 24h — reach signal TODAY.",
            hi: "ऐप पूरी तरह ऑफलाइन काम करता है। लाल बैनर = 24 घंटे पुराने रिकॉर्ड — आज ही सिग्नल क्षेत्र जाएँ।" },
        ],
      },
      {
        id: "insp-critical",
        heading: { en: "Critical defect", hi: "गंभीर दोष" },
        items: [
          { en: "Stop the loom, add a CRITICAL defect (photo forced), submit — the app stops the loom in the system and alerts the Supervisor automatically.",
            hi: "करघा रोकें, CRITICAL दोष जोड़ें, सबमिट करें — ऐप अपने आप पर्यवेक्षक को सूचित करेगा।" },
        ],
      },
      {
        id: "insp-rules",
        heading: { en: "Rules", hi: "नियम" },
        items: [
          { en: "Never share your login. Never estimate — measure twice. No editing after submit; call the Supervisor for corrections.",
            hi: "लॉगिन साझा न करें। अनुमान न लगाएँ। सबमिट के बाद संपादन नहीं — पर्यवेक्षक को कॉल करें।" },
        ],
      },
    ],
  },
  supervisor: {
    title: { en: "Supervisor — 4 daily screens + weekly + week one", hi: "पर्यवेक्षक — 4 दैनिक स्क्रीन + साप्ताहिक + पहले सप्ताह" },
    sections: [
      {
        id: "sup-daily",
        heading: { en: "Daily", hi: "रोज़ाना" },
        items: [
          { en: "Assignment Queue: assign an inspector to every new PO by zone and workload (warn > 40 looms); POs cannot issue without this.",
            hi: "असाइनमेंट क्यू: हर नए PO को ज़ोन और लोड के अनुसार इंस्पेक्टर दें (>40 करघे पर चेतावनी); बिना असाइनमेंट PO जारी नहीं होगा।" },
          { en: "Escalations Inbox: Critical first; resolve with written rework instruction — the loom stays stopped until then.",
            hi: "शिकायत बॉक्स: पहले Critical; लिखित सुधार निर्देश के साथ हल करें — तब तक करघा रुका रहेगा।" },
          { en: "Device Sync Status: any inspector red (> 24h) — call them today.",
            hi: "डिवाइस सिंक: कोई भी इंस्पेक्टर लाल (>24 घंटे) — आज ही कॉल करें।" },
          { en: "Live Board: red / amber looms are today's field visits.",
            hi: "लाइव बोर्ड: लाल/एम्बर करघे आज की फील्ड विज़िट हैं।" },
        ],
      },
      {
        id: "sup-weekly",
        heading: { en: "Weekly", hi: "साप्ताहिक" },
        items: [
          { en: "Route Planner — fix coverage warnings (Zone A daily, B alternate, C weekly).",
            hi: "रूट प्लानर — कवरेज चेतावनियाँ ठीक करें (ज़ोन A रोज़, B एक-दिन छोड़, C साप्ताहिक)।" },
          { en: "Audit Mode — do at least 2 unannounced audits per week; a 2-level grade mismatch means retrain.",
            hi: "ऑडिट मोड — हफ्ते में कम से कम 2 अघोषित ऑडिट; 2-स्तर की ग्रेड भिन्नता = पुनः प्रशिक्षण।" },
          { en: "Grade Review — every revision needs a written reason.",
            hi: "ग्रेड समीक्षा — हर बदलाव के लिए लिखित कारण।" },
        ],
      },
      {
        id: "sup-week-one",
        heading: { en: "Week one", hi: "पहला सप्ताह" },
        items: [
          { en: "Fix Missing ETAs queue — 71 items, 5 working days, with Merchandisers.",
            hi: "ETA सही करें — 71 आइटम, 5 कार्यदिवस, मर्चेंडाइज़र के साथ।" },
          { en: "Vendor Not Allocated queue — 10 lines, 3 working days.",
            hi: "वेंडर आवंटित नहीं — 10 लाइन, 3 कार्यदिवस।" },
        ],
      },
    ],
  },
  coordinator: {
    title: { en: "Coordinator — master data + weekly MIS", hi: "कोऑर्डिनेटर — मास्टर डेटा + साप्ताहिक MIS" },
    sections: [
      {
        id: "coord-master",
        heading: { en: "Master data", hi: "मास्टर डेटा" },
        items: [
          { en: "Weaver / design / vendor names have ONE canonical spelling; only you create or rename.",
            hi: "बुनकर/डिज़ाइन/वेंडर के नाम की एक ही सही वर्तनी; केवल आप नाम बनाएँ या बदलें।" },
          { en: "Always search before creating; merge duplicates, never create them.",
            hi: "नया बनाने से पहले खोजें; डुप्लिकेट न बनाएँ, मर्ज करें।" },
        ],
      },
      {
        id: "coord-mis",
        heading: { en: "Weekly MIS — every Saturday", hi: "साप्ताहिक MIS — हर शनिवार" },
        items: [
          { en: "Review 4 sections; get Supervisor sign-off; export PDF + Excel; send by evening.",
            hi: "4 सेक्शन की समीक्षा; सुपरवाइज़र से हस्ताक्षर; PDF + Excel निर्यात; शाम तक भेजें।" },
        ],
      },
      {
        id: "coord-ongoing",
        heading: { en: "Ongoing", hi: "सतत" },
        items: [
          { en: "Check Import Health weekly; chase late reports via Supervisor — never fill missing data yourself.",
            hi: "साप्ताहिक इम्पोर्ट हेल्थ जाँचें; देर की रिपोर्ट सुपरवाइज़र से लें — खुद डेटा न भरें।" },
          { en: "Use Export CSV instead of parallel Excel — the app is the record.",
            hi: "समानांतर Excel के बजाय Export CSV का उपयोग करें — रिकॉर्ड ऐप ही है।" },
        ],
      },
    ],
  },
  merchandiser: {
    title: { en: "Merchandiser — new PO & tracking", hi: "मर्चेंडाइज़र — नया PO और ट्रैकिंग" },
    sections: [
      {
        id: "merch-new",
        heading: { en: "New PO", hi: "नया PO" },
        items: [
          { en: "ETA is mandatory — the form will not save without it.",
            hi: "ETA अनिवार्य है — बिना उसके फॉर्म सेव नहीं होगा।" },
          { en: "Add each carpet as a line item. Submit → Supervisor assigns inspector → only then ISSUED.",
            hi: "हर कालीन को लाइन आइटम के रूप में जोड़ें। सबमिट → सुपरवाइज़र इंस्पेक्टर देते हैं → तभी ISSUED।" },
          { en: "Do NOT share the PO with the weaver before status is ISSUED.",
            hi: "स्थिति ISSUED से पहले बुनकर को PO साझा न करें।" },
        ],
      },
      {
        id: "merch-track",
        heading: { en: "Tracking", hi: "ट्रैकिंग" },
        items: [
          { en: "My POs — pace flags (amber 5+, red 15+ behind — check reds daily).",
            hi: "मेरे PO — पेस फ्लैग (5+ एम्बर, 15+ लाल — लाल रोज़ देखें)।" },
          { en: "Open any carpet for latest photos and grade; extra visits via Supervisor only.",
            hi: "किसी भी कालीन पर नवीनतम फोटो व ग्रेड देखें; अतिरिक्त विज़िट केवल सुपरवाइज़र से।" },
          { en: "No pickup before Final-QC-before-cutting approval.",
            hi: "काटने-से-पहले फ़ाइनल QC अनुमोदन से पहले पिकअप नहीं।" },
        ],
      },
    ],
  },
  director: {
    title: { en: "Director — daily KPI wall, weekly review, monthly cadence",
             hi: "डायरेक्टर — दैनिक KPI, साप्ताहिक समीक्षा, मासिक चक्र" },
    sections: [
      {
        id: "dir-daily",
        heading: { en: "Daily — the KPI wall (5 min, morning)", hi: "रोज़ाना — KPI वॉल (सुबह 5 मिनट)" },
        items: [
          { en: "Open the Dashboard. Scan five numbers first: active looms, on-time %, looms by grade, open escalations by class, top 5 delayed POs.",
            hi: "डैशबोर्ड खोलें। पहले पाँच संख्याएँ देखें: सक्रिय करघे, समय-पर %, ग्रेड-वार करघे, वर्ग-वार खुली शिकायतें, शीर्ष 5 विलंबित PO।" },
          { en: "If Critical escalations > 0, drill in — a Supervisor must have a written rework instruction the same day.",
            hi: "Critical शिकायत > 0 हो तो अंदर जाएँ — सुपरवाइज़र से उसी दिन लिखित सुधार निर्देश चाहिए।" },
          { en: "Any inspector red in Device Sync (>24h unsynced) — ping the Supervisor immediately; on-time closure depends on daily photos.",
            hi: "Device Sync में कोई इंस्पेक्टर लाल (>24 घंटे) — तुरंत सुपरवाइज़र को बताएँ; समय-पर बंदी रोज़ की फोटो पर निर्भर है।" },
          { en: "Skim the Inspector League table — bottom-two inspectors get a one-on-one this week.",
            hi: "इंस्पेक्टर लीग टेबल देखें — नीचे के दो को इस हफ्ते वन-ऑन-वन।" },
        ],
      },
      {
        id: "dir-weekly",
        heading: { en: "Weekly — governance ceremony (Saturday, 30 min)", hi: "साप्ताहिक — शासन बैठक (शनिवार, 30 मिनट)" },
        items: [
          { en: "Sign off on the Coordinator's Weekly MIS (PDF + Excel) before it leaves the office.",
            hi: "कोऑर्डिनेटर की साप्ताहिक MIS (PDF + Excel) को ऑफिस से बाहर जाने से पहले स्वीकृति दें।" },
          { en: "Review Audit Mismatches — any 2-level grade gap this week is a retraining trigger.",
            hi: "ऑडिट मिसमैच देखें — इस हफ्ते किसी भी 2-स्तर की ग्रेड भिन्नता पर पुनःप्रशिक्षण।" },
          { en: "Approve or trim the coming week's Route Planner (coverage warnings must be zero).",
            hi: "आने वाले सप्ताह का Route Planner स्वीकार/काटें (कवरेज चेतावनियाँ शून्य)।" },
          { en: "Check Fix Missing ETAs and Vendor Not Allocated queues — both must trend to zero week over week.",
            hi: "ETA सही करें व वेंडर आवंटित नहीं क्यू — दोनों हर सप्ताह शून्य की ओर जाएँ।" },
        ],
      },
      {
        id: "dir-monthly",
        heading: { en: "Monthly — trend + people", hi: "मासिक — रुझान + लोग" },
        items: [
          { en: "Export PO Register CSV → month-on-month on-time %, A-grade closure %, defect classes.",
            hi: "PO रजिस्टर CSV निर्यात → माह-दर-माह समय-पर %, A-ग्रेड बंदी %, दोष वर्ग।" },
          { en: "Rebalance inspector loom-count if any inspector consistently exceeds 40 active looms.",
            hi: "यदि किसी इंस्पेक्टर के 40+ सक्रिय करघे लगातार हों तो लोड बदलें।" },
          { en: "Rotate one unannounced Audit round yourself with the Supervisor — sets tone.",
            hi: "स्वयं सुपरवाइज़र के साथ एक अघोषित ऑडिट राउंड करें — मानक तय होता है।" },
        ],
      },
      {
        id: "dir-people",
        heading: { en: "User management & governance", hi: "उपयोगकर्ता प्रबंधन" },
        items: [
          { en: "Only you (director) create/deactivate users and edit escalation contacts (Supervisor, Coordinator, Shagufta, Muzammil).",
            hi: "केवल आप (डायरेक्टर) उपयोगकर्ता बनाते/बंद करते हैं और संपर्क संपादित करते हैं।" },
          { en: "Never reseed the database in production — inspection & audit history is preserved by design and must never be wiped.",
            hi: "उत्पादन में डेटाबेस रीसीड न करें — निरीक्षण व ऑडिट इतिहास स्थायी है, इसे कभी न मिटाएँ।" },
          { en: "Grade revisions require a written reason and are traceable in Grade Review — treat them as coachable moments.",
            hi: "ग्रेड बदलाव के लिए लिखित कारण चाहिए और Grade Review में दृश्य है — इन्हें प्रशिक्षण अवसर मानें।" },
        ],
      },
    ],
  },
};

export const FAQ = [
  {
    id: "faq-1",
    q: { en: "Forgot password", hi: "पासवर्ड भूल गए" },
    a: { en: "Use the 'Forgot Password' OTP flow. If your phone number changed, only the admin can update it.",
         hi: "'पासवर्ड भूल गए' OTP का उपयोग करें। नंबर बदल गया हो तो केवल एडमिन ही अपडेट करेगा।" },
  },
  {
    id: "faq-2",
    q: { en: "No signal at the loom", hi: "करघे पर सिग्नल नहीं" },
    a: { en: "The app works fully offline. GPS works without internet. Keep Location ON.",
         hi: "ऐप पूरी तरह ऑफलाइन काम करता है। GPS बिना इंटरनेट के भी काम करता है। Location चालू रखें।" },
  },
  {
    id: "faq-3",
    q: { en: "Photo won't upload", hi: "फोटो अपलोड नहीं हो रही" },
    a: { en: "In signal area tap 'Sync Now'; close/reopen the app if needed. Records are safe — never delete-and-re-enter. If stuck >1 day, show your phone to the Supervisor.",
         hi: "सिग्नल क्षेत्र में 'अभी सिंक करें' दबाएँ; ज़रूरत हो तो ऐप बंद-खोलें। रिकॉर्ड सुरक्षित हैं — कभी हटाकर दोबारा न भरें। 1 दिन से अधिक अटका हो तो सुपरवाइज़र को फ़ोन दिखाएँ।" },
  },
  {
    id: "faq-4",
    q: { en: "Wrong entry after submit", hi: "सबमिट के बाद गलत प्रविष्टि" },
    a: { en: "No self-edit. Call the Supervisor — revisions keep full history.",
         hi: "स्वयं संपादन नहीं। सुपरवाइज़र को कॉल करें — बदलावों का पूरा इतिहास रहेगा।" },
  },
  {
    id: "faq-5",
    q: { en: "Lost or new phone", hi: "फोन खो गया / नया फोन" },
    a: { en: "Tell the Supervisor the same day for device sign-out. Unsynced records on a lost phone are gone — sync daily.",
         hi: "उसी दिन सुपरवाइज़र को बताएँ — डिवाइस साइन-आउट के लिए। खोए फ़ोन के unsynced रिकॉर्ड खो जाते हैं — रोज़ सिंक करें।" },
  },
  {
    id: "faq-6",
    q: { en: "WhatsApp reporting", hi: "WhatsApp रिपोर्टिंग" },
    a: { en: "During the 30-day parallel run use both. App-only after the announced kill-date. Use the Share-to-WhatsApp button when needed.",
         hi: "30-दिन के समानांतर चरण में दोनों उपयोग करें। घोषित तिथि के बाद केवल ऐप। ज़रूरत पर 'Share to WhatsApp' बटन।" },
  },
  {
    id: "faq-7",
    q: { en: "Red sync banner", hi: "लाल सिंक बैनर" },
    a: { en: "Records older than 24 hours are on the phone. Reach signal today — the Supervisor sees the same flag.",
         hi: "24 घंटे से अधिक पुराने रिकॉर्ड फ़ोन पर हैं। आज ही सिग्नल में पहुँचें — सुपरवाइज़र भी वही फ्लैग देखते हैं।" },
  },
  {
    id: "faq-8",
    q: { en: "GPS not working", hi: "GPS काम नहीं कर रहा" },
    a: { en: "Location ON at High Accuracy. Stand in the open 1–2 minutes. Restart the phone. Photos without GPS are refused by design.",
         hi: "Location को High Accuracy पर चालू रखें। 1–2 मिनट खुली जगह खड़े रहें। फ़ोन रीस्टार्ट करें। GPS के बिना फोटो जान-बूझकर मना कर दी जाती है।" },
  },
  {
    id: "faq-9",
    q: { en: "How do I log out or switch users?", hi: "लॉगआउट या उपयोगकर्ता कैसे बदलें?" },
    a: { en: "Top-right → Sign Out. Never share a phone between two users — audit history is tied to the login.",
         hi: "ऊपर दाएँ → Sign Out। दो लोगों के बीच फोन साझा न करें — ऑडिट इतिहास लॉगिन से जुड़ा है।" },
    keywords: ["logout", "log out", "signout", "sign out", "switch user", "लॉगआउट"],
  },
  {
    id: "faq-10",
    q: { en: "Why did the app suggest a lower grade than I wanted?", hi: "ऐप ने अपेक्षा से कम ग्रेड क्यों सुझाया?" },
    a: { en: "The app suggests C on any Critical defect or red pace flag, B on Major/amber, otherwise A. You can override — just write the reason. Supervisor sees both grades.",
         hi: "Critical/लाल पर C, Major/एम्बर पर B, वरना A सुझाया जाता है। आप बदल सकते हैं — कारण लिखें। दोनों ग्रेड सुपरवाइज़र को दिखते हैं।" },
    keywords: ["grade", "override", "suggested", "A", "B", "C", "ग्रेड"],
  },
  {
    id: "faq-11",
    q: { en: "Do I need to install an app from the Play Store?", hi: "क्या Play Store से ऐप इंस्टॉल करना ज़रूरी है?" },
    a: { en: "No — HAG runs in the phone browser (Chrome). Add it to Home Screen from the browser menu for a one-tap icon.",
         hi: "नहीं — HAG फोन के ब्राउज़र (Chrome) में चलता है। Home Screen में जोड़ें ताकि एक-टैप आइकन बने।" },
    keywords: ["install", "playstore", "play store", "download", "apk", "chrome", "home screen"],
  },
];

// Fixed escalation table (rendered as a table, non-editable).
export const ESCALATION_TABLE = [
  { situation: { en: "Critical defect on loom", hi: "करघे पर गंभीर दोष" },
    call: { en: "STOP loom → app defect entry → Supervisor", hi: "करघा रोकें → ऐप में दोष दर्ज → सुपरवाइज़र" },
    when: { en: "Immediately", hi: "तुरंत" } },
  { situation: { en: "App / login / sync problem", hi: "ऐप / लॉगिन / सिंक समस्या" },
    call: { en: "Supervisor", hi: "सुपरवाइज़र" },
    when: { en: "Same day", hi: "उसी दिन" } },
  { situation: { en: "Yarn below reorder level", hi: "धागा पुनःआदेश स्तर से कम" },
    call: { en: "Stores Coordinator → Shagufta", hi: "स्टोर्स कोऑर्डिनेटर → शगुफ़्ता" },
    when: { en: "Same day", hi: "उसी दिन" } },
  { situation: { en: "Weaver absent — loom idle", hi: "बुनकर अनुपस्थित — करघा खाली" },
    call: { en: "Production Supervisor", hi: "प्रोडक्शन सुपरवाइज़र" },
    when: { en: "By noon", hi: "दोपहर तक" } },
  { situation: { en: "Client quality complaint", hi: "क्लाइंट गुणवत्ता शिकायत" },
    call: { en: "Coordinator → Muzammil", hi: "कोऑर्डिनेटर → मुज़म्मिल" },
    when: { en: "24 hrs", hi: "24 घंटे" } },
  { situation: { en: "Piece fails Final QC", hi: "फ़ाइनल QC में विफल" },
    call: { en: "QC → Coordinator → Muzammil", hi: "QC → कोऑर्डिनेटर → मुज़म्मिल" },
    when: { en: "Same day", hi: "उसी दिन" } },
  { situation: { en: "Payment dispute (weaver)", hi: "भुगतान विवाद (बुनकर)" },
    call: { en: "Shagufta → Muzammil", hi: "शगुफ़्ता → मुज़म्मिल" },
    when: { en: "Same day", hi: "उसी दिन" } },
  { situation: { en: "Phone lost / changed", hi: "फ़ोन खो गया / बदला" },
    call: { en: "Supervisor (device sign-out)", hi: "सुपरवाइज़र (डिवाइस साइन-आउट)" },
    when: { en: "Same day", hi: "उसी दिन" } },
];

// Editable contact slots — Director can PATCH the phone via /api/settings/contacts.
export const CONTACT_SLOTS = [
  { key: "supervisor", label: { en: "Supervisor", hi: "सुपरवाइज़र" } },
  { key: "coordinator", label: { en: "Coordinator", hi: "कोऑर्डिनेटर" } },
  { key: "shagufta", label: { en: "Shagufta (Stores)", hi: "शगुफ़्ता (स्टोर्स)" } },
  { key: "muzammil", label: { en: "Muzammil (QC / Payments)", hi: "मुज़म्मिल (QC / भुगतान)" } },
];

export const HELP_UI = {
  title: { en: "Help", hi: "सहायता" },
  tab_guide: { en: "Guide", hi: "गाइड" },
  tab_faq: { en: "FAQ", hi: "सामान्य प्रश्न" },
  tab_contacts: { en: "Contacts", hi: "संपर्क" },
  show_both: { en: "Show both", hi: "दोनों दिखाएँ" },
  hide_both: { en: "Show one", hi: "एक दिखाएँ" },
  search_faq: { en: "Search FAQ…", hi: "FAQ खोजें…" },
  report_problem: { en: "Report a Problem", hi: "समस्या बताएँ" },
  report_desc: { en: "Describe what went wrong", hi: "क्या गलत हुआ बताएँ" },
  report_submit: { en: "Send to Supervisor", hi: "सुपरवाइज़र को भेजें" },
  report_queued_offline: { en: "Saved — will send when online.", hi: "सहेजा गया — ऑनलाइन होने पर भेजा जाएगा।" },
  report_sent: { en: "Sent to Supervisor's inbox.", hi: "सुपरवाइज़र के इनबॉक्स में भेज दिया गया।" },
  add_screenshot: { en: "Attach screenshot (optional)", hi: "स्क्रीनशॉट जोड़ें (वैकल्पिक)" },
  no_number: { en: "Not set", hi: "सेट नहीं" },
  situation: { en: "Situation", hi: "स्थिति" },
  who_to_call: { en: "Who to call", hi: "किसे कॉल करें" },
  when: { en: "When", hi: "कब" },
  edit_number: { en: "Edit", hi: "बदलें" },
  save_number: { en: "Save", hi: "सहेजें" },
  tap_to_call: { en: "Tap to call", hi: "कॉल करने के लिए टैप करें" },
  glossary: { en: "App glossary — read once, save time forever",
              hi: "ऐप शब्दावली — एक बार पढ़ें, हमेशा के लिए समय बचाएँ" },
  first_time: { en: "First-time setup (do these once)",
                hi: "पहली बार सेटअप (एक बार करें)" },
};

// Universal glossary — same for every role, appears below the role guide.
// Adoption killer #1 is people not knowing what a colour/badge means. Fix it here.
export const GLOSSARY = [
  {
    id: "gl-grade",
    heading: { en: "Loom grades A / B / C", hi: "करघा ग्रेड A / B / C" },
    items: [
      { en: "A (green) — no defects, on pace. Loom is healthy.",
        hi: "A (हरा) — कोई दोष नहीं, समय पर। करघा स्वस्थ।" },
      { en: "B (amber) — Major defect OR amber pace flag. Needs correction, not stop.",
        hi: "B (एम्बर) — बड़ा दोष या एम्बर पेस फ्लैग। सुधार चाहिए, रोकना नहीं।" },
      { en: "C (red) — Critical defect OR red pace flag. Loom auto-stops if Critical; needs escalation.",
        hi: "C (लाल) — गंभीर दोष या लाल पेस फ्लैग। Critical पर करघा स्वयं रुक जाता है; escalation चाहिए।" },
    ],
  },
  {
    id: "gl-pace",
    heading: { en: "Pace flags (green / amber / red)", hi: "पेस फ्लैग (हरा / एम्बर / लाल)" },
    items: [
      { en: "Green — actual % is within 5 points of expected. On track.",
        hi: "हरा — वास्तविक % अपेक्षा से 5 अंक के भीतर। सही रास्ते पर।" },
      { en: "Amber — 5–15 points behind. Watch daily; extra visits may be needed.",
        hi: "एम्बर — 5–15 अंक पीछे। रोज़ ध्यान रखें; अतिरिक्त विज़िट चाहिए।" },
      { en: "Red — >15 points behind. Merchandiser + Supervisor must intervene today.",
        hi: "लाल — 15+ अंक पीछे। मर्चेंडाइज़र + सुपरवाइज़र आज ही हस्तक्षेप करें।" },
    ],
  },
  {
    id: "gl-milestones",
    heading: { en: "Milestones (in strict order — none can be skipped)",
               hi: "मील-स्टोन (सख्त क्रम में — कोई छूटे नहीं)" },
    items: [
      { en: "Start → 10% → 25% → 40% → 55% → 70% → 85% → 100% → Final-QC-before-cutting.",
        hi: "Start → 10% → 25% → 40% → 55% → 70% → 85% → 100% → Final-QC-before-cutting।" },
      { en: "Ad-hoc = extra visit outside milestones (allowed anytime, doesn't advance stage).",
        hi: "Ad-hoc = मील-स्टोन के बाहर अतिरिक्त विज़िट (कभी भी, चरण नहीं बढ़ता)।" },
      { en: "PO cannot move to Received without a Final-QC-before-cutting entry approved by the Supervisor.",
        hi: "बिना Final-QC-before-cutting व सुपरवाइज़र स्वीकृति के PO Received नहीं होगा।" },
    ],
  },
  {
    id: "gl-po",
    heading: { en: "PO lifecycle (status chips)", hi: "PO जीवनचक्र (स्थिति चिप्स)" },
    items: [
      { en: "Draft → Pending Inspector Assignment → Issued → Raw Material Issued → In Progress (Daura) → Final QC → Received → Reconciliation → Closed. Cancelled is a terminal state.",
        hi: "Draft → Pending Inspector Assignment → Issued → Raw Material Issued → In Progress → Final QC → Received → Reconciliation → Closed। Cancelled अंतिम स्थिति है।" },
      { en: "'Draft — ETA Missing' means the PO was imported without a due date. Fix from the Supervisor's Fix Missing ETAs queue.",
        hi: "'Draft — ETA Missing' का अर्थ है ETA के बिना PO आयातित। सुपरवाइज़र के Fix Missing ETAs क्यू से ठीक करें।" },
    ],
  },
  {
    id: "gl-sync",
    heading: { en: "Sync banner colours", hi: "सिंक बैनर रंग" },
    items: [
      { en: "Green / hidden — everything synced.",
        hi: "हरा / छिपा — सब सिंक्ड।" },
      { en: "Amber — unsynced records < 24h. Sync when signal returns.",
        hi: "एम्बर — 24 घंटे से कम पुराने unsynced रिकॉर्ड। सिग्नल पर सिंक करें।" },
      { en: "Red — unsynced records > 24h. Reach signal TODAY.",
        hi: "लाल — 24 घंटे से अधिक पुराने रिकॉर्ड। आज ही सिग्नल क्षेत्र में जाएँ।" },
    ],
  },
  {
    id: "gl-costing",
    heading: { en: "Who sees costing", hi: "कॉस्टिंग कौन देखता है" },
    items: [
      { en: "Rate / margin / payable / billing fields are visible ONLY to Supervisor, Coordinator, Director. Inspectors and Merchandisers cannot see them.",
        hi: "रेट / मार्जिन / देय / बिलिंग फ़ील्ड केवल Supervisor, Coordinator, Director को दिखते हैं। Inspector व Merchandiser को नहीं।" },
    ],
  },
];

// First-time setup nudges — per role. Shown at the very top of the guide so a
// new user does the one-time things (permissions, contacts, imports) before their
// first real workflow.
export const FIRST_TIME = {
  inspector: [
    { en: "Allow Location — High Accuracy — for the app in Android Settings. Photos without GPS are refused.",
      hi: "Android सेटिंग में ऐप के लिए Location — High Accuracy दें। GPS के बिना फोटो अस्वीकृत होंगी।" },
    { en: "Allow Camera and Microphone (voice notes). Deny 'auto-clear on background' for HAG.",
      hi: "कैमरा व माइक्रोफ़ोन दें। HAG के लिए 'background में साफ़ करें' बंद रखें।" },
    { en: "Open Today's Route once with signal, so today's looms cache locally for offline use.",
      hi: "एक बार सिग्नल में Today's Route खोलें — करघे स्थानीय रूप से कैश हो जाएँगे।" },
  ],
  supervisor: [
    { en: "Ask the Director to set the 4 contact numbers under Help → Contacts (Supervisor, Coordinator, Shagufta, Muzammil).",
      hi: "डायरेक्टर से Help → Contacts में 4 संपर्क नंबर सेट करवाएँ।" },
    { en: "Set each Inspector's zone (A / B / C) in Master Data before assigning them to any new PO.",
      hi: "Master Data में हर इंस्पेक्टर के लिए ज़ोन (A/B/C) सेट करें, तभी नया PO असाइन करें।" },
    { en: "Clear the initial Fix Missing ETAs queue (71 items) and Vendor Not Allocated queue (10 lines) within Week 1.",
      hi: "पहले सप्ताह में Fix Missing ETAs (71) व Vendor Not Allocated (10) क्यू पूरा करें।" },
  ],
  coordinator: [
    { en: "Import the 3 master CSVs (Handwoven, Quality, LSD) once from Data Import, using the Preflight check first.",
      hi: "Data Import से 3 CSV (Handwoven, Quality, LSD) एक बार आयात करें — पहले Preflight जाँच लें।" },
    { en: "Confirm all vendors and weavers use canonical names (no duplicates) in Master Data.",
      hi: "Master Data में सभी वेंडर व बुनकर के नाम एक ही सही रूप में रखें (डुप्लिकेट न हो)।" },
  ],
  merchandiser: [
    { en: "Add yourself as a favourite pattern: New PO → save your usual product category once.",
      hi: "एक बार सामान्य product category सेव करें — New PO जल्दी बनेगा।" },
    { en: "Bookmark the My POs page — pace flags update every 30 seconds while it is open.",
      hi: "My POs पेज बुकमार्क करें — खुला रहने पर हर 30 सेकंड में पेस फ्लैग अपडेट होते हैं।" },
  ],
  director: [
    { en: "Fill in the 4 escalation contact numbers under Help → Contacts. These are the numbers everyone sees.",
      hi: "Help → Contacts में 4 escalation संपर्क नंबर भरें — सभी को ये दिखेंगे।" },
    { en: "Approve the initial user list (3 inspectors, 1 supervisor, 1 coordinator, 2 merchandisers, 1 director) and rotate passwords from the seed default.",
      hi: "प्रारंभिक उपयोगकर्ता सूची स्वीकृत करें और seed पासवर्ड बदलें।" },
    { en: "Read the acceptance criteria in the PRD (Product Requirements Document) once so you know exactly what the app enforces (mandatory ETA, milestone order, grade revision reasons, etc.).",
      hi: "PRD (Product Requirements Document) की acceptance criteria एक बार पढ़ें — ऐप क्या-क्या लागू करता है, यह पता चलेगा।" },
  ],
};

export function pickLang(pair, lang, showBoth) {
  if (!pair) return "";
  if (showBoth) {
    if (lang === "en") return { primary: pair.en, secondary: pair.hi };
    return { primary: pair.hi, secondary: pair.en };
  }
  return { primary: pair[lang] || pair.en, secondary: null };
}
